<template>
  <div class="box4"></div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.box4 {
  width: 100%;
  height: 300px;
  background: #dbf4ff;
  background: url("../../../assets/coursePage/newMedia/box4/bgc.png") no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
